// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import { Base, PopoverIcon, Switch } from '@gandi/ui';

import { ListRow } from './ListRow';

type Props = {
  onChange?: (checked: boolean) => Promise<mixed>,
  checked: boolean,
  id: string,
  name: string,
  popoverText?: string,
  title?: string,
};
export function AutoRenewBlock({
  name,
  id,
  checked,
  onChange,
  title,
  popoverText,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const [disabled, setDisabled] = React.useState<boolean>(false);

  const handleChange = async (evt: SyntheticInputEvent<>) => {
    setDisabled(true);
    try {
      // $FlowFixMe[not-a-function]
      await onChange(evt.target.checked);
    } finally {
      setDisabled(false);
    }
  };

  return (
    <ListRow
      title={
        <Base flex gap="xxsmall">
          {title || __('Automatic renewal')}
          <PopoverIcon icon="infoWire" id={`icon-${id}`}>
            {popoverText ||
              __(
                'When reaching the expiration date, we will automatically renew products for you. ' +
                  "This is handy for products you don't want to lose. " +
                  'The renewal will be done on the saved credit card or on the related prepaid account.',
              )}
          </PopoverIcon>
        </Base>
      }
      cta={
        onChange && (
          <Switch
            name={name}
            checked={checked}
            onChange={handleChange}
            variant="compact"
            disabled={disabled}
          >
            {__('Automatic renewal')}
          </Switch>
        )
      }
      intent={checked ? 'success' : 'off'}
    />
  );
}
